// extracted by mini-css-extract-plugin
module.exports = {"labelText":"styles-module--labelText--DZOe8","body":"styles-module--body--1WksE"};